import {
  Link,
  V2MailIcon,
  V2ShareFacebookIcon,
  V2ShareTwitterIcon,
  v2neutral100,
  v2blue600,
} from '@paypalcorp/pp-react';
import React from 'react';
import * as analytics from '../lib/analytics';

const socialShareIconsStyle = {
  padding: '13px 13px',
  borderRadius: '30px',
  backgroundColor: v2neutral100,
  height: '48px',
  width: '48px',
  margin: '0px 10px',
  display: 'flex',
};

export default class extends React.Component {
  handleClick = (event) => {
    event.preventDefault();
  };

  handleFBClick = (socialShareType, url) => {
    let fbShareMsg = this.props.fbDesc;
    let name = this.props.fbTitle;
    let link = url;
    let caption = this.props.i18n('label.fb-caption');
    let picture = `https://${this.props.cdnHost}/webstatic/icon/pp258.png`;
    let constructUrl = `https://www.facebook.com/dialog/feed?app_id=321983581337375&name=${name}&display=popup&caption=${caption}&description=${fbShareMsg}&picture=${picture}&link=${link}`;
    window.open(
      constructUrl,
      'facebook',
      'toolbar=0,status=0,width=640,height=340,scrollable=true'
    );

    analytics.trackLink(
      socialShareType,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  };

  handleAnalytics = (socialShareType) => {
    analytics.trackLink(
      socialShareType,
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      'link'
    );
  };

  handleKeyPress(e, callback) {
    if (e.key === 'Enter') {
      return callback();
    }
  }

  render() {
    let twitterShareMsg = this.props.i18n('label.twitter-share-msg');
    let mailShareMsg = this.props.i18n('label.mail-share-msg');
    let twitterUrl = encodeURI(
      'https://twitter.com/intent/tweet?text=' + twitterShareMsg
    );
    let mailSubject = this.props.i18n('label.mail-subject');
    let mailUrl = `mailto:?subject=${mailSubject}&body=${mailShareMsg}`;

    return (
      <div className='share-social' style={this.props.style}>
        <ul
          style={{
            listStyle: 'none',
          }}
        >
          <li
            tabIndex='0'
            onKeyDown={(e) =>
              this.handleKeyPress(
                e,
                this.handleFBClick.bind(this, 'facebookshare', this.props.url)
              )
            }
            style={{
              ...socialShareIconsStyle,
              ...this.props.socialShareIconsStyle,
            }}
          >
            <Link
              leftIcon={<V2ShareFacebookIcon size='sm' />}
              onClick={this.handleFBClick.bind(
                this,
                'facebookshare',
                this.props.url
              )}
              style={{ color: v2blue600 }}
              role='link'
              aria-label={this.props.i18n('label.fb-Link')}
            />
          </li>
          <li
            tabIndex='0'
            onKeyDown={(e) =>
              this.handleKeyPress(e, () => {
                this.handleAnalytics.bind(this, 'twittershare');
                window.open(twitterUrl, '_blank');
              })
            }
            style={{
              ...socialShareIconsStyle,
              ...this.props.socialShareIconsStyle,
            }}
          >
            <Link
              leftIcon={<V2ShareTwitterIcon size='sm' />}
              onClick={() => {
                this.handleAnalytics.bind(this, 'twittershare');
                window.open(twitterUrl, '_blank');
              }}
              style={{ color: v2blue600 }}
              role='link'
              aria-label={this.props.i18n('label.twitter-link')}
            />
          </li>
          <li
            tabIndex='0'
            onKeyDown={(e) =>
              this.handleKeyPress(e, () => {
                this.handleAnalytics.bind(this, 'twittershare');
                window.open(mailUrl, '_blank');
              })
            }
            style={{
              ...socialShareIconsStyle,
              ...this.props.socialShareIconsStyle,
            }}
          >
            <Link
              leftIcon={<V2MailIcon size='sm' />}
              onClick={() => {
                this.handleAnalytics.bind(this, 'mailshare');
                window.open(mailUrl, '_blank');
              }}
              style={{ color: v2blue600 }}
              role='link'
              aria-label={this.props.i18n('label.mail-link')}
            />
          </li>
        </ul>
      </div>
    );
  }
}
